// extracted by mini-css-extract-plugin
export default {"row":"FetchErrorNotification_row__lx1-8"};